import { Button, Grid } from '@mui/material';
import styles from 'assets/css/wizard.module.css';
import BackSvg from 'assets/img/form-backbtn.svg';
import {useMediaQuery} from "hooks/useMediaQuery";

const Wizard = (props) => {
  const { children, titleText, backStepHandler, icon } = props;
  return (
    <Grid container className={styles.wrapper}>
      <Header title={titleText} backStepHandler={backStepHandler} icon={icon} />
      <Grid item xs={12}>
        {children}
      </Grid>
    </Grid>
  );
};

const Header = ({ title, backStepHandler, icon }) => {
    const isDesktop = useMediaQuery('(min-width: 1024px)');

    return (
    <Grid item xs={12}>
      <Grid container xs={12} className={styles.header}>
        <Grid item xs={1}>
          <img src={icon} />
        </Grid>
        <Grid item xs={10} textAlign="center">
          {title}
        </Grid>
        <Grid item xs={1} textAlign="left">
          <Button
            onClick={backStepHandler}
            sx={{
              borderRadius: '50%',
              minWidth: isDesktop?'48px':'26px',
              height: isDesktop?'48px':'26px',
              background: '#FFFFFF',
              padding: 0,
              border: '1px solid #F5F5F5',
              boxShadow:
                '-2px -2px 7px #FFFFFF, 1px 1px 10px rgba(0, 0, 0, 0.10)'
            }}
          >
            <img style={{width:isDesktop?'24px':'18px'}} src={BackSvg} alt="" />
          </Button>
        </Grid>
      </Grid>
        {!isDesktop&&<div className={styles.border} style={{ width: `35%` }} />}
    </Grid>
  );
};

export { Wizard };
